// **************************************************************
// !!!IMPORTANT!!! LAST IP NUMBER SHOULD BE BETWEEN .50 AND .255
// **************************************************************
// That range is what the mocked API's TLS certificate covers (see its
// src/certificates/README.md). An IP outside it fails the handshake.

export const MOCKED_API_LOCAL_HOST = 'https://localhost:3010';
export const MOCKED_API_NETWORK_HOST = 'https://192.168.1.133:3010';
